import { render } from "./ContactMain.vue?vue&type=template&id=4baec20c&scoped=true"
import script from "./ContactMain.vue?vue&type=script&lang=js"
export * from "./ContactMain.vue?vue&type=script&lang=js"

import "./ContactMain.vue?vue&type=style&index=0&id=4baec20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baec20c"]])

export default __exports__